import React, { useState, useEffect } from 'react';
import { FaTrash, FaChevronDown, FaChevronUp, FaEnvelope, FaTimes } from "react-icons/fa";
import { useTranslation } from 'react-i18next';

const RegisteredUsersTable = ({ users, onDelete, sessionRegistrationCounts, countries, cities, onSendEmail, onSendGroupEmail }) => {
  const { i18n } = useTranslation();
  const [filterCountry, setFilterCountry] = useState('');
  const [filterCity, setFilterCity] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [expandedSessionId, setExpandedSessionId] = useState(null);

  const [showAllSessionsModal, setShowAllSessionsModal] = useState(false);
  const [sessionsForModal, setSessionsForModal] = useState([]);
  const [selectedUserName, setSelectedUserName] = useState('');

  const [filteredUsers, setFilteredUsers] = useState([]);

  useEffect(() => {
    let currentFilteredUsers = users;

    if (filterCountry) {
      currentFilteredUsers = currentFilteredUsers.filter(user =>
        user.countryName.toLowerCase().includes(filterCountry.toLowerCase())
      );
    }

    if (filterCity) {
      currentFilteredUsers = currentFilteredUsers.filter(user =>
        user.cityName.toLowerCase().includes(filterCity.toLowerCase())
      );
    }

    if (searchTerm) {
      currentFilteredUsers = currentFilteredUsers.filter(user =>
        user.firstName.toLowerCase().includes(searchTerm.toLowerCase()) ||
        user.lastName.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    if (expandedSessionId) {
      currentFilteredUsers = currentFilteredUsers.filter(user =>
        user.sessionIds && user.sessionIds.includes(expandedSessionId)
      );
    }

    setFilteredUsers(currentFilteredUsers);
  }, [users, filterCountry, filterCity, searchTerm, expandedSessionId]);

  if (!users || users.length === 0) {
    return <p>Aucun utilisateur inscrit pour le moment.</p>;
  }

  const handleSessionClick = (sessionId) => {
    setExpandedSessionId(prevId => (prevId === sessionId ? null : sessionId));
  };

  const handleSendEmailToSession = () => {
    const emails = filteredUsers.map(user => user.email);
    if (emails.length > 0) {
      onSendGroupEmail(emails);
    }
  };

  const formatSessionDateTime = (dateString, type, lang) => {
    if (!dateString) return `Date ${type} non disponible`;
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return `Date ${type} invalide`;

    if (type === 'start') {
      return `${date.toLocaleDateString(lang)} ${date.toLocaleTimeString(lang)}`;
    } else if (type === 'end') {
      return `${date.toLocaleTimeString(lang)}`;
    }
    return '';
  };

  return (
      <>
          {sessionRegistrationCounts && (
              <div className="table-container">
                  <h3>Statistiques d'inscription par session</h3>
                  <div className="stats-grid-wrapper">
                      <div className="session-stats-summary">
                          {Object.entries(sessionRegistrationCounts).map(
                              ([sessionId, sessionData]) => {
                                  const city = cities.find(
                                      (c) => c.id === sessionData.cityId
                                  );
                                  const country = countries.find(
                                      (co) => co.id === city?.countryId
                                  );
                                  const cityName = city
                                      ? city.name[i18n.language.split("-")[0]]
                                      : "N/A";
                                  const countryName = country
                                      ? country.name[
                                            i18n.language.split("-")[0]
                                        ]
                                      : "N/A";

                                  return (
                                      <div
                                          key={sessionId}
                                          className="stat-card session-card"
                                          onClick={() =>
                                              handleSessionClick(sessionId)
                                          }
                                      >
                                          <h4>{sessionData.title}</h4>
                                          <p>{sessionData.totalCount}</p>
                                          <small>
  {sessionData.address}<br/> {/* Add address here */}
  {cityName}, {countryName} -
  {sessionData.start_time && sessionData.end_time ? (
    <div>
      {new Date(sessionData.start_time).toLocaleDateString(i18n.language)} {new Date(sessionData.start_time).toLocaleTimeString(i18n.language)} - {new Date(sessionData.end_time).toLocaleTimeString(i18n.language)}
    </div>
  ) : (
    'Pas de dates disponibles'
  )}
  <span style={{ color: 'green', fontWeight: 'bold', display: 'block', marginTop: '5px' }}>{sessionData.language}</span>
</small>
                                          {expandedSessionId === sessionId ? (
                                              <FaChevronUp />
                                          ) : (
                                              <FaChevronDown />
                                          )}
                                      </div>
                                  );
                              }
                          )}
                      </div>
                  </div>
              </div>
          )}

          <div className="filter-bar">
              <span>Filtrer par:</span>
              <input
                  type="text"
                  placeholder="Pays"
                  value={filterCountry}
                  onChange={(e) => setFilterCountry(e.target.value)}
              />
              <input
                  type="text"
                  placeholder="Ville"
                  value={filterCity}
                  onChange={(e) => setFilterCity(e.target.value)}
              />
              <input
                  type="text"
                  placeholder="Rechercher par nom/prénom"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
              />
          </div>

          {expandedSessionId && (
              <div className="expanded-session-details">
                  <h4>
                      Utilisateurs inscrits pour la session:{" "}
                      {sessionRegistrationCounts[expandedSessionId]?.title} (
                      {sessionRegistrationCounts[expandedSessionId]?.address})
                  </h4>
                  <button
                      onClick={handleSendEmailToSession}
                      className="action-btn btn-email"
                      style={{ marginBottom: "15px" }}
                  >
                      Envoyer email à tous ceux inscrits à cette session
                  </button>
                  <table>
                      <thead>
                          <tr>
                              <th>Prénom</th>
                              <th>Nom</th>
                              <th>Email</th>
                              <th>Pays</th>
                              <th>Ville</th>
                              <th>Téléphone</th>
                              <th>Date d'inscription</th>
                              <th>Session(s)</th>
                              <th>Actions</th>
                          </tr>
                      </thead>
                      <tbody>
                          {[...filteredUsers]
                              .sort(
                                  (a, b) =>
                                      new Date(b.registrationDate) -
                                      new Date(a.registrationDate)
                              )
                              .map((user) => (
                                  <tr key={user.id}>
                                      <td>{user.firstName}</td>
                                      <td>{user.lastName}</td>
                                      <td>{user.email}</td>
                                      <td>{user.countryName}</td>
                                      <td>{user.cityName}</td>
                                      <td>{user.phoneNumber}</td>
                                      <td>
                                          {new Date(
                                              user.registrationDate
                                          ).toLocaleDateString()}
                                      </td>
                                      <td>
                                          {user.sessions &&
                                          user.sessions.length > 0 ? (
                                              <>
                                                  <div
                                                      style={{
                                                          marginBottom: "5px",
                                                      }}
                                                  >
                                                      <span>
                                                          {
                                                              user.sessions[0]
                                                                  .title
                                                          }
                                                      </span>{" "}
                                                      <span
                                                          style={{
                                                              fontStyle:
                                                                  "italic",
                                                              color: "#555",
                                                          }}
                                                      >
                                                          (
                                                          {
                                                              user.sessions[0]
                                                                  .language
                                                          }
                                                          )
                                                      </span>
                                                      <small
                                                          style={{
                                                              display: "block",
                                                              opacity: 0.7,
                                                          }}
                                                      >
                                                          {
                                                              user.sessions[0]
                                                                  .address
                                                          }
                                                      </small>
                                                  </div>
                                                  {user.sessions.length > 1 && (
                                                      <span
                                                          className="show-more-sessions"
                                                          onClick={(e) => {
                                                              e.stopPropagation();
                                                              setShowAllSessionsModal(
                                                                  true
                                                              );
                                                              setSessionsForModal(
                                                                  user.sessions
                                                              );
                                                              setSelectedUserName(
                                                                  `${user.firstName} ${user.lastName}`
                                                              );
                                                          }}
                                                      >
                                                          (+{" "}
                                                          {user.sessions
                                                              .length - 1}{" "}
                                                          autres)
                                                      </span>
                                                  )}
                                              </>
                                          ) : (
                                              <span>N/A</span>
                                          )}
                                      </td>
                                      <td className="action-cell">
                                          <button
                                              title="Envoyer un email"
                                              onClick={() =>
                                                  onSendEmail(user.email)
                                              }
                                              className="action-btn btn-email"
                                          >
                                              <FaEnvelope />
                                          </button>
                                      </td>
                                  </tr>
                              ))}
                      </tbody>
                  </table>
              </div>
          )}

          {!expandedSessionId && (
              <div className="all-users-table">
                  <h4>Tous les utilisateurs inscrits</h4>
                  <table>
                      <thead>
                          <tr>
                              <th>Prénom</th>
                              <th>Nom</th>
                              <th>Email</th>
                              <th>Pays</th>
                              <th>Ville</th>
                              <th>Téléphone</th>
                              <th>Date d'inscription</th>
                              <th>Session(s)</th>
                              <th>Actions</th>
                          </tr>
                      </thead>
                      <tbody>
                          {[...filteredUsers]
                              .sort(
                                  (a, b) =>
                                      new Date(b.registrationDate) -
                                      new Date(a.registrationDate)
                              )
                              .map((user) => (
                                  <tr key={user.id}>
                                      <td>{user.firstName}</td>
                                      <td>{user.lastName}</td>
                                      <td>{user.email}</td>
                                      <td>{user.countryName}</td>
                                      <td>{user.cityName}</td>
                                      <td>{user.phoneNumber}</td>
                                      <td>
                                          {new Date(
                                              user.registrationDate
                                          ).toLocaleDateString()}
                                      </td>
                                      <td>
                                          {user.sessions &&
                                          user.sessions.length > 0 ? (
                                              <>
                                                  <div
                                                      style={{
                                                          marginBottom: "5px",
                                                      }}
                                                  >
                                                      <span>
                                                          {
                                                              user.sessions[0]
                                                                  .title
                                                          }
                                                      </span>{" "}
                                                      <span
                                                          style={{
                                                              fontStyle:
                                                                  "italic",
                                                              color: "#03c65bff",
                                                              fontWeight:
                                                                  "bolder",
                                                          }}
                                                      >
                                                          (
                                                          {
                                                              user.sessions[0]
                                                                  .language
                                                          }
                                                          )
                                                      </span>
                                                      <small
                                                          style={{
                                                              display: "block",
                                                              opacity: 0.7,
                                                          }}
                                                      >
                                                          {
                                                              user.sessions[0]
                                                                  .address
                                                          }
                                                      </small>
                                                  </div>
                                                  {user.sessions.length > 1 && (
                                                      <span
                                                          className="show-more-sessions"
                                                          onClick={(e) => {
                                                              e.stopPropagation();
                                                              setShowAllSessionsModal(
                                                                  true
                                                              );
                                                              setSessionsForModal(
                                                                  user.sessions
                                                              );
                                                              setSelectedUserName(
                                                                  `${user.firstName} ${user.lastName}`
                                                              );
                                                          }}
                                                      >
                                                          (+{" "}
                                                          {user.sessions
                                                              .length - 1}{" "}
                                                          autres)
                                                      </span>
                                                  )}
                                              </>
                                          ) : (
                                              <span>N/A</span>
                                          )}
                                      </td>
                                      <td className="action-cell">
                                          <button
                                              title="Envoyer un email"
                                              onClick={() =>
                                                  onSendEmail(user.email)
                                              }
                                              className="action-btn btn-email"
                                          >
                                              <FaEnvelope />
                                          </button>
                                      </td>
                                  </tr>
                              ))}
                      </tbody>
                  </table>
              </div>
          )}

          {showAllSessionsModal && (
              <div className="modal-overlay">
                  <div className="modal-content">
                      <h2>Sessions pour {selectedUserName}</h2>
                      <button
                          onClick={() => setShowAllSessionsModal(false)}
                          className="modal-close-button"
                      >
                          <FaTimes />
                      </button>
                      <div className="session-list-in-modal">
                          {sessionsForModal.map((session, index) => (
                              <div
                                  key={index}
                                  style={{
                                      marginBottom: "10px",
                                      borderBottom: "1px solid #eee",
                                      paddingBottom: "5px",
                                  }}
                              >
                                  <p>
                                      <strong>{session.title}</strong>{" "}
                                      <span
                                          style={{
                                              fontStyle: "italic",
                                              color: "#03c65bff",
                                              fontWeight: "bolder",
                                          }}
                                      >
                                          ({session.language})
                                      </span>
                                  </p>
                                  <p>
                                      <small>{session.address}</small>
                                  </p>
                                  <p>
                                      <small>
                                          {formatSessionDateTime(
                                              session.startTime,
                                              "start",
                                              i18n.language
                                          )}
                                          {" - "}
                                          {formatSessionDateTime(
                                              session.endTime,
                                              "end",
                                              i18n.language
                                          )}
                                      </small>
                                  </p>
                              </div>
                          ))}
                      </div>
                  </div>
              </div>
          )}
      </>
  );
};

export default RegisteredUsersTable;